import { BuildingAmenityType } from "../../../Types/buildingAmenityTypes"
import QuickForm from "../QuickForm/QuickForm"

export default function BuildingAmenityForm(props: {
    disabled: boolean,
    onSubmit: (v: any) => Promise<any>,
    initialValues?: Partial<BuildingAmenityType>,
    buildingOptions?: { value: string, text: string }[],
    amenityOptions?: { value: string, text: string }[],
}) {
    const {
        disabled,
        onSubmit,
        initialValues,
        buildingOptions = [],
        amenityOptions = [],
    } = props

    return (
        <div className="building-amenity-form">
            <QuickForm
                showErrors={true}
                initialData={{
                    buildingId: '',
                    amenityId: '',
                    overrides: {},
                    ...(initialValues ? { ...initialValues } : {}),
                }}
                fields={[
                    {
                        fieldName: 'buildingId',
                        fieldLabel: 'Building',
                        fieldType: 'select',
                        placeholder: '- Select Building -',
                        required: true,
                        options: buildingOptions,
                        layout: { xs: 12, md: 6 },
                    },
                    {
                        fieldName: 'amenityId',
                        fieldLabel: 'Amenity',
                        fieldType: 'select',
                        placeholder: '- Select Amenity -',
                        required: true,
                        options: amenityOptions,
                        layout: { xs: 12, md: 6 },
                    },
                ]}
                disabled={disabled}
                onSubmit={onSubmit}
            />
        </div>
    )
}
